<template>
  <footer class="row" :class="{ desktop: $isDesktop }">
    <translate
      tag="button"
      type="button"
      class="button sml minimal close-btn"
      @click="$emit('cancel')"
    >
      Close
    </translate>
    <base-submit-button
      data-test="filter-and-sort-update-search"
      class="button primary asblock"
      @click="$emit('updateSearch')"
    >
      {{ $t('Update') }}
      <translate v-if="searchWizardStore.showCount && count" :tt="{ count }">
        ({count, number})
      </translate>
      <template #submittingText>
        {{ $t('Updating...') }}
      </template>
    </base-submit-button>
  </footer>
</template>

<script lang="ts">
import { Component, Vue, toNative } from '~/utility/pu-class-decorator'

@Component({
  emits: ['updateSearch'],
  setup() {
    const searchWizardStore = useSearchWizardStore(usePinia())
    return {
      searchWizardStore,
    }
  },
})
class FilterAndSortFooter extends Vue {
  searchWizardStore: ReturnType<typeof useSearchWizardStore>

  get count() {
    return this.searchWizardStore.totalCounts
  }
}

export default toNative(FilterAndSortFooter)
</script>

<style scoped>
footer {
  align-items: flex-start;
  background-color: white;
  bottom: 0;
  box-shadow: 0 -0.3em 0.5em rgba(0, 0, 0, 0.2);
  height: auto;
  justify-content: space-between;
  left: 0;
  padding: 0.4em 1em 0.6em;
  position: fixed;
  width: 100%;
  z-index: 9;
}

span {
  font-weight: normal;
  color: #b8ddbf;
  margin-left: 0.3em;
}

footer .primary {
  padding: 0.6em 1em 0.5em;
}

.close-btn {
  border-color: var(--colour-light-grey);
  color: var(--text-default);
}

/* desktop & tablet */
footer.desktop button.asblock {
  display: inline-block;
  width: auto;
}
</style>
